import React from 'react';
import { Navigate } from 'react-router-dom';
import Unknown from 'screens/Unknown';
import WithoutAccess from 'screens/WithoutAccess';
import AuthLoading from 'components/AuthLoading/AuthLoading';
import { can } from '../../auth/permissions';
import { IAuth, AuthStatus } from '../../store/types/auth';
import { APP_ROUTES, LANDING_CANDIDATES } from './routeTable';

type RouteEntry = { path: string; element: JSX.Element };

/**
 * Route list for the signed-in user: every entry of APP_ROUTES whose requirement the user
 * satisfies (moderators satisfy all of them), `/` redirecting to the first page they may open,
 * and a 404 catch-all. While the Cognito session is still being read only a loader is routed.
 */
export const routes = (auth: IAuth | undefined, status: AuthStatus | undefined): RouteEntry[] => {
    if (!status || status === 'idle' || status === 'loading') return [{ path: '/*', element: <AuthLoading /> }];
    if (!auth?.isLoggedIn) return [{ path: '/*', element: <Unknown /> }];

    const { permissions } = auth;
    const landing = LANDING_CANDIDATES.find((candidate) => can(permissions, candidate.requires));
    return [
        { path: '/', element: landing ? <Navigate to={landing.path} replace /> : <WithoutAccess /> },
        ...APP_ROUTES.filter((route) => can(permissions, route.requires)).map(({ path, element }) => ({ path, element })),
        { path: '/*', element: <Unknown /> },
    ];
};
